<template>
    <div v-loading="loading" class="user-portfolio-vacancies">
        <div class="user-portfolio-vacancies__head">
            <div class="user-portfolio-vacancies__head-title">
                <span>Заявки на вакансии</span>
                <strong v-if="vacancies.length" @click="popupOpened = true">
                    {{ vacancies.length }}
                </strong>
            </div>
            <div
                v-if="vacancies.length > limit"
                class="user-portfolio-vacancies__head-see-all"
                @click="popupOpened = true"
            >
                Смотреть все
            </div>
        </div>
        <div v-if="vacancies.length" class="user-portfolio-vacancies__list">
            <div
                v-for="(item, index) in vacanciesLimited"
                :key="index"
                class="user-portfolio-vacancies__list-item"
            >
                <div class="user-portfolio-vacancies__list-item-name">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div v-else class="user-portfolio-vacancies__empty">
            Пользователь еще не подавал заявок
        </div>

        <Modal :opened="popupOpened" @close="popupOpened = false">
            <div v-loading="loading" class="user-portfolio-vacancies__inner">
                <div class="user-portfolio-vacancies__inner-head">
                    <div class="user-portfolio-vacancies__inner-title">
                        <span>Подавал заявки на вакансии: </span>
                        <strong v-if="vacancies.length">
                            {{ vacancies.length }}
                        </strong>
                    </div>
                </div>
                <div
                    v-for="(item, index) in vacancies"
                    :key="index"
                    class="user-portfolio-vacancies__inner-list-item"
                >
                    <div class="user-portfolio-vacancies__inner-list-item-name">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
} from "vuex";
import Modal from "@/components/UI/Modal.vue";

export default {
    components: {
        Modal,
    },
    data: () => ({
        loading: false,
        limit: 4,
        popupOpened: false,
        vacancies: [],
    }),
    async created() {
        this.loading = true;
        try {
            await this.loadRegistryItems({ type: 'vacancies' });
        } catch(e) {} finally {
            await this.initVacancies(this.getUser.userId);
            this.setUserVacanciesSPK(this.vacancies);
            this.loading = false;
        }
    },
    watch: {
        async 'getUser.userId'(userId) {
            this.loading = true;

            await this.initVacancies(userId);

            this.loading = false;
        },
    },
    computed: {
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('newUsers', [
            'getUser',
        ]),
        vacanciesLimited() {
            return ([...this.vacancies]).slice(0, this.limit);
        },
    },
    methods: {
        ...mapActions('data', [
            'loadRegistryItems',
        ]),
        ...mapActions('newUsers', [
            'loadUserVacancies',
        ]),
        ...mapActions('competences', [
            'loadCompetencesByType',
        ]),
        ...mapMutations('newUsers', [
            'setUserVacanciesSPK',
        ]),

        async initVacancies(userId) {
            if (this.getRegistryItems('spk_project_type').length === 0) {
                await this.loadRegistryItems({ type: 'spk_project_type', withDeleted: true });
            }

            const projectSPKTypes = this.getRegistryItems('spk_project_type')
                .filter(v => ['vacancy'].indexOf(v.field_name) !== -1)
                .map(v => v.id)
            ;

            try {
                this.vacancies = await this.loadUserVacancies({
                    userId: userId,
                    filters: {
                        types: projectSPKTypes,
                    },
                });
            } catch (e) {
                this.vacancies = [];
            }
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-vacancies {
    display: flex;
    flex-direction: column;
    gap: mrem(40);

    @include on-desktop {
        gap: rem(40);
    }

    &__head {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: mrem(16);

        @include on-desktop {
            gap: rem(16);
            align-items: center;
            flex-direction: row;
        }

        &-title {
            font-weight: 700;
            font-size: mrem(18);
            line-height: mrem(24);

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(24);
            }

            strong {
                color: $color-main-blue;
                font-weight: 500;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &-see-all {
            color: $color-main-blue;
            font-weight: 400;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &__list {
        display: flex;
        flex-direction: column;
        gap: mrem(20);

        @include on-desktop {
            gap: rem(20);
        }

        &-item {
            background: $color-main-notice-lighter;
            display: flex;
            flex-direction: column;
            padding: mrem(20) mrem(16);
            border-radius: mrem(16);
            gap: mrem(16);

            @include on-desktop {
                padding: rem(20) rem(16);
                border-radius: rem(16);
                gap: rem(16);
            }

            &-name {
                font-weight: 700;
            }
        }
    }

    &__empty {
        color: $color-main-primary;
        font-weight: 500;
    }

    &__inner {
        @include on-desktop {
            width: rem(600);
        }
    }

    &__inner-head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    &__inner-title {
        font-weight: 700;
        font-size: mrem(24);
        line-height: mrem(22);
        margin-bottom: mrem(24);

        @include on-desktop {
            font-size: rem(24);
            line-height: rem(22);
            margin-bottom: rem(24);
        }

        strong {
            color: $color-main-blue;
            font-weight: 500;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &__inner-list-item {
        background: $color-main-notice-lighter;
        display: flex;
        flex-direction: column;
        padding: mrem(20) mrem(16);
        border-radius: mrem(16);
        gap: mrem(16);
        margin-bottom: mrem(16);

        @include on-desktop {
            padding: rem(20) rem(16);
            border-radius: rem(16);
            gap: rem(16);
            margin-bottom: rem(16);
        }
    }

    &__inner-list-item-name {
        font-weight: 700;
    }

}

</style>
